import { render, staticRenderFns } from "./fix_order.vue?vue&type=template&id=2ec532ea&scoped=true"
import script from "./fix_order.vue?vue&type=script&lang=js"
export * from "./fix_order.vue?vue&type=script&lang=js"
import style0 from "./fix_order.vue?vue&type=style&index=0&id=2ec532ea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec532ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec532ea')) {
      api.createRecord('2ec532ea', component.options)
    } else {
      api.reload('2ec532ea', component.options)
    }
    module.hot.accept("./fix_order.vue?vue&type=template&id=2ec532ea&scoped=true", function () {
      api.rerender('2ec532ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/fix_order/fix_order.vue"
export default component.exports